import React from "react";
import "./LivoraFeedback.css";

function LivoraModalCard({ dialog, onClose }) {
  if (!dialog?.open) return null;

  const confirmClass =
    dialog.variant === "danger"
      ? "gate-btn gate-btn-danger"
      : dialog.variant === "payment"
      ? "gate-btn gate-btn-pay"
      : "gate-btn gate-btn-pay";

  return (
    <div className="gate-overlay" onClick={onClose}>
      <div
        className="gatecard-center"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-live="polite"
      >
        <div className="gatecard-title">{dialog.title}</div>

        <div className="gatecard-sub">{dialog.message}</div>

        <div className="gatecard-actions">
          <button
            type="button"
            className="gate-btn gate-btn-cancel"
            onClick={onClose}
            disabled={dialog.loading}
          >
            {dialog.cancelText}
          </button>

          <button
            type="button"
            className={confirmClass}
            onClick={dialog.onConfirm}
            disabled={dialog.loading}
          >
            {dialog.loading ? "..." : dialog.confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default LivoraModalCard;